import styled from "styled-components";
import theme from 'common/theme';
export const DatePickerButtonContainer = styled.div<{gridCols?: string}>`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  min-width: max-content;
  width: max-content;
  justify-self: end;
  position: relative;
  font-size: ${theme.font.sizes.res};

  .calendar-button {
    font-size: .9em;
    font-weight: 400;

   
  }
  .dropdown-area {
    border-radius: ${theme.radius.base};
    box-shadow: ${theme.effects.boxShadow.main};
    display: none;
    position: absolute;
    top: 100%;
    right: 0;
    background-color: white;
    
 
    transform: translateY(-2px);
 

    &.is-open {
      display: block;
      z-index: 900;
    }
  }

  .date-display {
    min-width: 10em;
  }
  .scrollable-area {
    display: grid;
    padding: inherit;
    grid-template-columns: ${({ gridCols }) => gridCols || '1fr'};
    grid-template-rows:auto;
  }
  
  .toggle-section {
    border-top: 0px;
    padding: 0 0.75em;

    section{
      display: flex;
      justify-content: space-between;
      padding: 0;

      .time-group{
        .value{
          font-size: 0.9em;
          font-weight: 500;
          text-align: center;
        }
      }
    }
  }

  .main-calendar-area {
    width: max-content;
    padding: .5em .5em 0;
    background-color: white;
    border-radius: ${theme.radius.base} 0 0 0;
  }
  
  .submit-btn-row {
    display: flex;
    justify-content: space-between;
    padding: inherit;
    padding: .5em;
    gap: 1em;
    border-top: solid 1px ${theme.colors.border.lightest};

    button{
      width: 100%;
      border-radius: ${theme.radius.base};
    }

  }

    
  .current-range-row, 
  .col-left,
  .col-right {
    border-color: ${theme.colors.border.lightest};
    border-style: solid;
    padding: .75em;
    background-color: white;
  }

  


 
  .toggle-section-title {
    font-weight: 500;
    text-transform: capitalize;
   
  }
  .col-left { border-width: 0 1px 0 0; }
  .col-right { border-width: 0 0 0 1px; }

  .current-range-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    column-gap: 1em;
    row-gap: .3em ;
    border-width: 1px 0 0 0;
   
  }

  
  select {
    margin-bottom: 1em;
    border-color: ${theme.colors.border.main};
    font-size: 1em;
    font-weight: 500;
    border-radius: ${theme.radius.sm};
    font-family: roboto, sans-serif;
    text-transform: capitalize;
    padding: .3em;
    
    option {
       font-size: 1em;
      font-weight: 400;
      color: black;
      text-transform: capitalize;
      padding: .3em .5em;
      border: none;
    }
  }

 
   
  .current-range-row .label,
  .side-column-group-label {
    font-size: 1em;
    color: black;
    margin: 0 0 .5em 0;
    padding: 0;
    font-weight: 500;
    text-transform: capitalize;
  }

  .side-column-group-label,
  .side-column-group-options {
  font-size: .9em;
  font-family: inherit;
  }

   
  .current-range-row .label {
  font-size: .8em;
}

`

export const IconButtonContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: .5em;
  font-size: 1em;
  border: 0;
  background-color: transparent;
  display: block;
  cursor: pointer;

  .icon--chevron-right {
    width: .9em;
    height: .9em;
  }
  &.left {
    .icon--chevron-right {
      transform: rotate(180deg);
    }
  }

  &.right {
    .icon--chevron-right {
      transform: rotate(0deg);
    }
  }
`


export const RangeItemContainer = styled.div`
  display: grid;
  grid-template-rows: auto auto auto auto auto;
  grid-template-columns: auto auto auto auto auto;
  gap: .3em;
  max-width: max-content;

  &.disabled {
    display: none;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    
    &:hover svg path { stroke: ${theme.colors.jbtBlue}; }
    &.up { transform: rotate(180deg) translateX(2px)}
    &.down { transform: translateX(1px) }

    svg {
      width: .8em;
      height: .8em;
    }

    .value {
      width: max-content;
    }

    .hour {
      text-align: right;
    }

  }

  
`